import {inject} from "@angular/core";
import {HttpInterceptorFn} from "@angular/common/http";
import {GeoService} from "../services/geo.service";

export const geoInterceptor: HttpInterceptorFn = (req, next) => {
    const geoService = inject(GeoService);
    const countryCode = geoService.getCountryCode();
    console.log(`[GeoInterceptor] Adding X-Country-Code: ${countryCode}`);
    const cloned = req.clone({
        headers: req.headers.set('X-Country-Code', countryCode)
    });
    return next(cloned);
};
